import React, { useState } from "react";

import { updatePartner } from "services";

import { incomplete, useCancelAsyncOnUnmount } from "utils";

import { MODULE_ACCESS } from "consts";

import { AdminSection, Button, Col, Drawer, Form, Input, InputNumber, Option, PageSpin, Row, Select, Message as message } from "components";

export const PartnerSettings = ({ partner, onUpdateSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirmDrawer, setShowDeleteConfirmDrawer] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const complete = (v) => {
    const invoiceAddress = `${v.addressStreet}, ${v.addressNumber}`;
    const invoiceCity = `${v.zip}, ${v.addressCity}`;

    setLoading(true);
    updatePartner({
      ...v,
      invoiceAddress,
      invoiceCity,
      id: partner.id,
      signal,
    })
      .then(() => {
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
        onUpdateSuccess();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDisablePartnerModalOpen = (disabled) => {
    if (!disabled) {
      return;
    }
    setShowDeleteConfirmDrawer(true);
  };

  return loading || !partner ? (
    <PageSpin />
  ) : (
    <>
      <Form className="midi-form" name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
        <AdminSection headline="General details" />
        <Row>
          <Col sm={20} md={20}>
            <Input name="name" label="Name" rules={[{ required: true }]} initialValue={partner.name} />
          </Col>
          <Col sm={4} md={4}>
            <Select name="disabled" label="Active" rules={[{ required: true }]} initialValue={!!partner.disabled} onChange={handleDisablePartnerModalOpen}>
              <Option value={false}>Yes</Option>
              <Option value={true}>No</Option>
            </Select>
          </Col>
        </Row>
        <Row>
          <Col sm={24}>
            <Select name="farmerModuleAccess" label="Farmer Module Access" rules={[{ required: true }]} initialValue={partner.farmerModuleAccess}>
              <Option value={MODULE_ACCESS.ALL}>All</Option>
              <Option value={MODULE_ACCESS.UNLIMITED}>Unlimited</Option>
              <Option value={MODULE_ACCESS.NONE}>None</Option>
            </Select>
          </Col>
        </Row>

        <AdminSection headline="Point prices" />
        <Row>
          <Col md={6}>
            <InputNumber
              initialValue={partner.pointPriceCategory1}
              name="pointPriceCategory1"
              label="Point price category 1"
              rules={[{ required: true }]}
              min={0}
              max={1}
              step={0.001}
            />
          </Col>
          <Col md={6}>
            <InputNumber
              initialValue={partner.pointPriceCategory1}
              name="pointPriceCategory2"
              label="Point price category 2"
              rules={[{ required: true }]}
              min={0}
              max={1}
              step={0.001}
            />
          </Col>
          <Col md={6}>
            <InputNumber
              initialValue={partner.pointPriceCategory1}
              name="pointPriceCategory3"
              label="Point price category 3"
              rules={[{ required: true }]}
              min={0}
              max={1}
              step={0.001}
            />
          </Col>
          <Col md={6}>
            <InputNumber
              initialValue={partner.pointPriceCategory4}
              name="pointPriceCategory4"
              label="Point price category 4"
              rules={[{ required: true }]}
              min={0}
              max={1}
              step={0.001}
            />
          </Col>
        </Row>

        <AdminSection headline="Contact info" />
        <Row>
          <Col>
            <Input name="contactName" label="Contact person" rules={[{ required: false }]} initialValue={partner.contactName} />
          </Col>
        </Row>
        <Row>
          <Col sm={24} md={12}>
            <Input name="contactEmail" label="Contact email" rules={[{ required: false }]} initialValue={partner.contactEmail} />
          </Col>
          <Col sm={24} md={12}>
            <Input name="contactPhone" label="Contact phone" rules={[{ required: false }]} initialValue={partner.contactPhone} />
          </Col>
        </Row>

        <AdminSection headline="Invoicing info" />
        <Row>
          <Col sm={24} md={18}>
            <Input name="addressStreet" label="Street" rules={[{ required: true }]} initialValue={partner.invoiceAddress?.split(", ")[0]} />
          </Col>
          <Col sm={24} md={6}>
            <Input name="addressNumber" label="Street Number" rules={[{ required: true }]} initialValue={partner.invoiceAddress?.split(", ")[1]} />
          </Col>
        </Row>

        <Row>
          <Col sm={24} md={18}>
            <Input name="addressCity" label="City" rules={[{ required: true }]} initialValue={partner.invoiceCity?.split(", ")[1]} />
          </Col>
          <Col sm={24} md={6}>
            <InputNumber name="zip" label="ZIP" rules={[{ required: true }]} initialValue={partner.invoiceCity?.split(", ")[0]} />
          </Col>
        </Row>

        <Row>
          <Col sm={24} md={24}>
            <Input name="invoiceCountry" label="Country" rules={[{ required: true }]} initialValue={partner.invoiceCountry} />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                Save
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Drawer
        footer={<Button onClick={() => setShowDeleteConfirmDrawer(false)}>Yes, I understand</Button>}
        placement="right"
        title="Disable partner"
        visible={showDeleteConfirmDrawer}
        onClose={() => setShowDeleteConfirmDrawer(false)}
      >
        <p>If you disable {partner.name}, all farmers who have been assigned to this partner will be unassigned.</p>
        <p>All assigned farmers switch will back to their default hectare limit and carbon price.</p>
        <p>You must manually remove any assigned credits if required.</p>
      </Drawer>
    </>
  );
};
